import React, { useState, useEffect } from 'react';
import { Table, Card, Button } from 'antd';
import { OperationService } from '@gtpl/shared-services/production';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { Link } from 'react-router-dom';
import { LotClubbingViewReq } from '@gtpl/shared-models/production-management';

const LotClubbingView = () => {
  const [data, setData] = useState([]);
  const [childData, setChildData] = useState({});
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const service = new OperationService();

  const getData = () => {
    setLoading(true);
    service.getAllLotClubbingView().then((res) => {
      setLoading(false);
      if (res.status) {
        setData(res.data);
      } else {
        AlertMessages.getErrorMessage(res.internalMessage);
        setData([]);
      }
    }).catch(() => {
      setLoading(false);
      AlertMessages.getErrorMessage('Error fetching parent data');
    });
  };

  useEffect(() => {
    getData();
  }, []);

  const fetchChildData = async (lotId) => {
    try {
      let req = new LotClubbingViewReq();
      req.lotId = lotId;

      const res = await service.getAllLotClubbingChildView(req);
      if (res.status) {
        return res.data;    
      } else {
        AlertMessages.getErrorMessage(res.internalMessage);
        return [];
      }
    } catch {
      AlertMessages.getErrorMessage('Error fetching child data');
      return [];
    }
  };

  const handleExpand = async (expanded, record) => {
    if (expanded) {
      if (!childData[record.main_lot_number]) {
        const data = await fetchChildData(record.lot_id);
        setChildData((prevData) => ({
          ...prevData,
          [record.lot_id]: data,
        }));
      }
      setExpandedRowKeys((prevKeys) => [...prevKeys, record.lot_id]);
    } else {
      setExpandedRowKeys((prevKeys) => prevKeys.filter(key => key !== record.lot_id));
    }
  };

  const columns = [
    {
      title: 'S.no',
      key: 'sNo',
      render: (text, object, index) => (page - 1) * pageSize + (index + 1),
    },
    {
        title: 'Operation',
        dataIndex: 'operation',
        key: 'operation',
      },
    {
      title: 'Batch Number',
      dataIndex: 'main_lot_number',
      key: 'lotNumber',
    },
    {
      title: 'Count',
      dataIndex: 'count',
      key: 'count',
      render: (text) => (text === '-' || parseFloat(text) === 0 ? '-' : parseFloat(text).toFixed(2)),
    },
    {
      title: 'Quantity Available',
      dataIndex: 'qty_avail',
      key: 'qty_avail',
      render: (text) => (text === '-' || parseFloat(text) === 0 ? '-' : parseFloat(text).toFixed(2)),
    },
    {
      title: 'Quantity After Clubbing',
      dataIndex: 'qty_aft_club',
      key: 'qty_aft_club',
      render: (text) => (text === '-' || parseFloat(text) === 0 ? '-' : parseFloat(text).toFixed(2)),
      
    },
    {
        title: 'Purpose',
        dataIndex: 'purpose',
        key: 'purpose',
      },
  ];

  const childColumns = [
    {
        title: 'S.no',
        key: 'sNo',
        render: (text, object, index) => (page - 1) * pageSize + (index + 1),
      },
    {
      title: 'Batch Number',
      dataIndex: 'lot_number',
      key: 'lot_number',
    },
    {
        title: 'Count',
        dataIndex: 'COUNT',
        key: 'count',
        render: (text) => (text === '-' || parseFloat(text) === 0 ? '-' : parseFloat(text).toFixed(2)),
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
      render: (text) => (text === '-' || parseFloat(text) === 0 ? '-' : parseFloat(text).toFixed(2)),    
    },

  ];
  
  return (
    <Card      
    title={<span style={{ color: 'white' }}>Clubbed Lot</span>}
    extra={
      <Link to="/lot-clubbing">
        <Button type="primary">Create</Button>
      </Link>
    }
    style={{ textAlign: 'center' }}
    headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
  >
      <Table
        columns={columns}
        dataSource={data}
        rowKey={(record) => record.lot_id}
        expandable={{
          expandedRowRender: (record) => (
            <Table
              columns={childColumns}
              dataSource={childData[record.lot_id] || []}
              pagination={false}
              size="small"
            />
          ),
          expandRowByClick: true,
          expandedRowKeys: expandedRowKeys,
          onExpand: handleExpand,

        rowExpandable: (record) => record.count >= 0,
        expandIconColumnIndex: columns.length,
        }}
        pagination={{
          current: page,
          pageSize: pageSize,
          onChange: (page, pageSize) => {
            setPage(page);
            setPageSize(pageSize);
          },
        }}
        loading={loading}
        size="small"
        
      />
    </Card>
  );
};

export default LotClubbingView;
